/* KROMA — shared behaviours (Horizon theme) */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.kr-reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14 });
    els.forEach(function (e) { io.observe(e); });
  }

  document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  // Shopify theme editor: re-run when a section is reloaded
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });

  window.KROMA = window.KROMA || {};
  window.KROMA.initReveal = initReveal;
})();
